import { render, staticRenderFns } from "./pagination-component.vue?vue&type=template&id=81ad139a&"
import script from "./pagination-component.vue?vue&type=script&lang=js&"
export * from "./pagination-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports